import type { YadavDiamond } from '@commerce/types/diamond'
import type { ProductVariant } from '@commerce/types/product'
import formatDiamondTitle from './format-diamond-title'

export const gtagEvent = (
  eventName: string,
  productVariant?: ProductVariant | null,
  diamond?: YadavDiamond | null
) => {
  if (typeof window !== 'undefined' && window.gtag) {
    try {
      if (productVariant && diamond) {
        window.gtag('event', eventName, {
          currency: productVariant.price.currencyCode || 'USD',
          value: productVariant.price.value + Number(diamond.price),
          items: [
            {
              item_id: productVariant.sku,
              item_name: productVariant.name,
              affiliation: 'Yadav Diamonds and Jewelry',
              item_brand: 'Yadav Diamonds and Jewelry',
              item_variant: productVariant.options[0]?.values[0]?.label,
              location_id: `${process.env.showroomPlaceId}`,
              price: productVariant.price.value,
              quantity: 1,
            },
            {
              item_id: `YD${diamond.id}`,
              item_name: formatDiamondTitle(diamond),
              affiliation: 'Yadav Diamonds and Jewelry',
              item_brand: 'Yadav Diamonds and Jewelry',
              location_id: `${process.env.showroomPlaceId}`,
              price: Number(diamond.price),
              quantity: 1,
            },
          ],
        })
      } else if (productVariant && !diamond) {
        window.gtag('event', eventName, {
          currency: productVariant.price.currencyCode || 'USD',
          value: productVariant.price.value,
          items: [
            {
              item_id: productVariant.sku,
              item_name: productVariant.name,
              affiliation: 'Yadav Diamonds and Jewelry',
              item_brand: 'Yadav Diamonds and Jewelry',
              item_variant: productVariant.options[0]?.values[0]?.label,
              location_id: `${process.env.showroomPlaceId}`,
              price: productVariant.price.value,
              quantity: 1,
            },
          ],
        })
      } else if (diamond) {
        window.gtag('event', eventName, {
          currency: 'USD',
          value: Number(diamond.price),
          items: [
            {
              item_id: `YD${diamond.id}`,
              item_name: formatDiamondTitle(diamond),
              affiliation: 'Yadav Diamonds and Jewelry',
              item_brand: 'Yadav Diamonds and Jewelry',
              location_id: `${process.env.showroomPlaceId}`,
              price: Number(diamond.price),
              quantity: 1,
            },
          ],
        })
      }
    } catch (error) {
      console.error(error)
    }
  }
}
